import { EntityState } from './models';
/**
 * @template V
 * @return {?}
 */
export function getInitialEntityState<V>(): EntityState<V> {
  return {
    ids: [],
    entities: {},
  };
}
/**
 * @template V
 * @return {?}
 */
export function createInitialStateFactory<V>() {
  function getInitialState(): EntityState<V>;
  function getInitialState<S extends object>(
    additionalState: S
  ): EntityState<V> & S;
/**
 * @param {?=} additionalState
 * @return {?}
 */
function getInitialState(additionalState: any = {}): any {
    return Object.assign(getInitialEntityState(), additionalState);
  }

  return { getInitialState };
}



// WEBPACK FOOTER //
// ../../../modules/entity/src/entity_state.ts